export default __webpack_public_path__ + "images/noimage.67b3677cde0bbffbb79322134c91bbda.jpg";